import React, { useEffect, useMemo, useState } from 'react';
import * as Yup from 'yup';
import { hasPermission } from '@app/helpers/permissions';
import {
  Button,
  FormatText,
  FormCheckbox,
  FormNumber,
  FormRadio,
  FormSubmitButton,
  FormSwitch,
  GridView,
  MasterDetailForm,
  usePromise,
  Widget,
} from '@digital/ui';
import { Collapse, Icon } from 'antd';

import CurrencyInput from '@app/components/CurrencyInput';

import { GetQaqc, UpdateQaqc } from '@app/api/configuracoes';

const ConfiguracaoQaqc = () => {
  const [onupdate, setOnupdate] = useState(false);

  const [dadosQaqc] = usePromise(async () => await GetQaqc(), [onupdate], {});
  const update = values => {
    UpdateQaqc(values).then(data => {
      if (data.valid) {
        setOnupdate(!onupdate);
      }
    });
  };

  const { Panel } = Collapse;
  return (
    <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
      <Panel key="configuracoesQaqc" header="Parâmetros Controle de Qualidade">
        <MasterDetailForm
          initialValues={dadosQaqc}
          onSubmit={update}
          validationSchema={Yup.object().shape({
            qaqcQuantidadeContratosFixos: Yup.number()
              .transform(value => (isNaN(value) ? undefined : value))
              .required('O campo deve ser informado'),
            qaqcQuantidadeContratosAleatorios: Yup.number()
              .transform(value => (isNaN(value) ? undefined : value))
              .required('O campo deve ser informado'),
            qaqcValorMedioUltimasMedicoes: Yup.number()
              .transform(value => (isNaN(value) ? undefined : value))
              .required('O campo deve ser informado'),
            qaqcQuantidadeMedicoesParaMedia: Yup.number()
              .transform(value => (isNaN(value) ? undefined : value))
              .required('O campo deve ser informado'),
          })}>
          <Widget
            actions={[
              hasPermission(['CONFIGURACAO_QAQC_EDITAR']) && (
                <FormSubmitButton noIcon={true} type="primary">
                  <FormatText id="ui.commons.save" uppercase />
                </FormSubmitButton>
              ),
            ]}>
            <FormNumber label="Quantidades Contratos Fixos" name="qaqcQuantidadeContratosFixos" span={3} />
            <FormNumber label="Quantidades Contratos Aleatórios" name="qaqcQuantidadeContratosAleatorios" span={3} />
            <CurrencyInput label="Valor Médio das Últimas Medições" name="qaqcValorMedioUltimasMedicoes" span={3} />
            <FormNumber label="Quantidade de Medições para Média" name="qaqcQuantidadeMedicoesParaMedia" span={3} />
            <FormSwitch label="Rotina de Criação Controle de Qualidade" name="qaqcRotinaGeracaoQAQC" span={3}/>
          </Widget>
        </MasterDetailForm>
      </Panel>
    </Collapse>
  );
};

export default ConfiguracaoQaqc;
